import { Component } from '@angular/core';

@Component({
    selector: 'app-detail-faq',
    templateUrl: './detail-faq.component.html',
    styleUrls: ['./detail-faq.component.scss']
})
/** detail-faq component*/
export class DetailFaqComponent {
    /** detail-faq ctor */
    constructor() {

    }
}


// WEBPACK FOOTER //
// ./src/app/faq-components/detail-faq/detail-faq.component.ts